import React, { Component } from 'react'

import Searchbar from '../../utils/Searchbar'
import SearchCategory from '../../search/SearchCategory'

class CategoriesSearch extends Component {
    render() {
        return (
            <div>
                <Searchbar placeholder={"Search categories"} component={SearchCategory} searchEndpoint={'search/category'} {...this.props} userType="admin" />
            </div>
        )
    }
}

export default CategoriesSearch



// WEBPACK FOOTER //
// ./src/components/admin/categories/CategoriesSearch.js